import {
    Button,
    Flex,
    HStack,
    Text,
} from "@chakra-ui/react";

import {
    ChevronLeft,
    ChevronRight,
} from "lucide-react";

const DataTablePagination = ({
    page = 1,
    pageSize = 10,
    total = 0,
    onPageChange,
}) => {
    const totalPages =
        Math.max(
            1,
            Math.ceil(
                total /
                    pageSize
            )
        );

    const start =
        total === 0
            ? 0
            : (page - 1) *
                  pageSize +
              1;

    const end = Math.min(
        page * pageSize,
        total
    );

    return (
        <Flex
            direction={{
                base: "column",
                md: "row",
            }}
            justify="space-between"
            align={{
                base: "stretch",
                md: "center",
            }}
            p={6}
            gap={4}
            borderTop="1px solid"
            borderColor="gray.100"
        >
            <Text
                color="gray.500"
                fontSize="sm"
            >
                Showing {start}–
                {end} of {total} records
            </Text>

            <HStack
                justify="center"
                flexWrap="wrap"
            >
                <Button
                    size="sm"
                    variant="outline"
                    disabled={
                        page === 1
                    }
                    onClick={() =>
                        onPageChange(
                            page - 1
                        )
                    }
                >
                    <ChevronLeft size={16} />
                </Button>

                {Array.from({
                    length:
                        totalPages,
                }).map(
                    (_, index) => {
                        const current =
                            index +
                            1;

                        return (
                            <Button
                                key={
                                    current
                                }
                                size="sm"
                                variant={
                                    current ===
                                    page
                                        ? "solid"
                                        : "outline"
                                }
                                bg={
                                    current ===
                                    page
                                        ? "#2453FF"
                                        : undefined
                                }
                                color={
                                    current ===
                                    page
                                        ? "white"
                                        : undefined
                                }
                                onClick={() =>
                                    onPageChange(
                                        current
                                    )
                                }
                            >
                                {
                                    current
                                }
                            </Button>
                        );
                    }
                )}

                <Button
                    size="sm"
                    variant="outline"
                    disabled={
                        page ===
                        totalPages
                    }
                    onClick={() =>
                        onPageChange(
                            page + 1
                        )
                    }
                >
                    <ChevronRight size={16} />
                </Button>
            </HStack>
        </Flex>
    );
};

export default DataTablePagination;